import { useRef, useState, useEffect, forwardRef } from "react";
import './CustomScrollbar.css';
import { ScrollContext } from "./ScrollContext";

const CustomScrollbar = forwardRef(({ children }, forwardedRef) => {
  const containerRef = useRef(null);

  const setRefs = (node) => {
    containerRef.current = node;
    if (typeof forwardedRef === "function") forwardedRef(node);
    else if (forwardedRef) forwardedRef.current = node;
  };

  const thumbRef = useRef(null);
  const [thumbHeight, setThumbHeight] = useState(20);
  const [thumbTop, setThumbTop] = useState(0);
  const isDragging = useRef(false);
  const startY = useRef(0);
  const startScrollTop = useRef(0);

  const updateThumb = () => {
    const el = containerRef.current;
    if (!el) return;
    const ratio = el.clientHeight / el.scrollHeight;
    setThumbHeight(ratio * el.clientHeight);
    setThumbTop((el.scrollTop / el.scrollHeight) * el.clientHeight);
  };

  useEffect(() => {
    const el = containerRef.current;
    el.addEventListener("scroll", updateThumb);
    updateThumb();
    return () => el.removeEventListener("scroll", updateThumb);
  }, []);

  const handleMouseDown = (e) => {
    isDragging.current = true;
    startY.current = e.clientY;
    startScrollTop.current = containerRef.current.scrollTop;
    document.body.style.userSelect = "none";
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isDragging.current) return;
      const el = containerRef.current;
      const deltaY = e.clientY - startY.current;
      const ratio = el.scrollHeight / el.clientHeight;
      el.scrollTop = startScrollTop.current + deltaY * ratio;
    };

    const handleMouseUp = () => {
      isDragging.current = false;
      document.body.style.userSelect = "";
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  return (
    <ScrollContext.Provider value={containerRef}>
      <div style={{ position: "relative", display: "flex", height: "100vh" }}>
        <div
          ref={setRefs}
          style={{ overflowY: "scroll", scrollbarWidth: "none", flex: 1, height: "100%" }}
        >
          {children}
        </div>

        <div style={{
          position: "absolute",
          right: 5,
          top: 0,
          width: "6px",
          height: "100%",
          background: "transparent",
          zIndex: 1001,
        }}>
          <div
            ref={thumbRef}
            onMouseDown={handleMouseDown}
            style={{
              position: "absolute",
              top: thumbTop,
              width: "100%",
              height: thumbHeight,
              background: "#7c3aed",
              borderRadius: "999px",
              cursor: "grab",
            }}
          />
        </div>
      </div>
    </ScrollContext.Provider>
  );
});

CustomScrollbar.displayName = "CustomScrollbar";
export default CustomScrollbar;